import { useEffect } from 'react'

type VisibilityCallback = (isForeground: boolean) => void

const usePageVisibility = (callback: VisibilityCallback) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        callback(true) // 페이지가 포어그라운드로 전환됨
      } else {
        callback(false) // 페이지가 백그라운드로 전환됨
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [callback])
}

export default usePageVisibility
